import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  greeting: () => i18n.t(i18nKeys.dropshippingStatus__greeting),
  subTitle: () => i18n.t(i18nKeys.dropshippingStatus__subTitle),
  backgroundCheckStep: () =>
    i18n.t(i18nKeys.dropshippingStatus__backgroundCheckStep),
  addBankAccountStep: () =>
    i18n.t(i18nKeys.dropshippingStatus__addBankAccountStep),
  redCardEntryStep: () => i18n.t(i18nKeys.dropshippingStatus__redCardEntryStep),
  startDashingStep: () => i18n.t(i18nKeys.dropshippingStatus__startDashingStep),
  activationKitStep: () =>
    i18n.t(i18nKeys.dropshippingStatus__activationKitStep),
  fastPayStep: () =>
    i18n.t(i18nKeys.dropshippingStatus__fastPayStep),
  backgroundCheckComplete: () =>
    i18n.t(i18nKeys.dropshippingStatus__backgroundCheckComplete),
  redCardEntryComplete: () =>
    i18n.t(i18nKeys.dropshippingStatus__redCardEntryComplete),
  addBankAccountComplete: () =>
    i18n.t(i18nKeys.dropshippingStatus__addBankAccountComplete),
  fastPayComplete: () => i18n.t(i18nKeys.dropshippingStatus__fastPayComplete),
  optional: () => i18n.t(i18nKeys.fastPay__onboarding__optional)
}

export const background = {
  alertTitle: () => i18n.t(i18nKeys.dropshippingStatus__backgroundAlertTitle),
  alertBody: () => i18n.t(i18nKeys.dropshippingStatus__backgroundAlertBody),
  completeText: () =>
    i18n.t(i18nKeys.dropshippingStatus__backgroundCompleteText),
  delayedTimeText: () =>
    i18n.t(i18nKeys.dropshippingStatus__backgroundDelayedTimeText),
  timeText: () => i18n.t(i18nKeys.dropshippingStatus__backgroundTimeText),
  button: () => i18n.t(i18nKeys.dropshippingStatus__backgroundButton),
}

export const activation = {
  shippedText: address =>
    i18n.t(i18nKeys.dropshippingStatus__activationShippedText, { address }),
  beingPreparedText: address =>
    i18n.t(i18nKeys.dropshippingStatus__activationBeingPreparedText, {
      address,
    }),
  futureMessage: address =>
    i18n.t(i18nKeys.dropShippingStatus__activationFutureMessage, { address }),
  pastMessage: address =>
    i18n.t(i18nKeys.dropShippingStatus__activationPastMessage, {
      address,
    }),
  pastMessageWithDate: (address, date) =>
    i18n.t(i18nKeys.dropShippingStatus__activationPastMessageWithDate, {
      address,
      date,
    }),
  statusLabel: () => i18n.t(i18nKeys.dropshippingStatus__activationStatusLabel),
  statusInProgress: () =>
    i18n.t(i18nKeys.dropshippingStatus__activationStatusInProgress),
  statusDelivered: () =>
    i18n.t(i18nKeys.dropshippingStatus__activationStatusDelivered),
  expectedDeliveryDateLabel: () =>
    i18n.t(i18nKeys.dropshippingStatus__activationExpectedDeliveryDateLabel),
  trackButton: () => i18n.t(i18nKeys.dropshippingStatus__activationTrackButton),
  activationKitModalButton: () =>
    i18n.t(i18nKeys.dropshippingStatus__activationKitModalButton),
}

export const redCard = {
  activate: () => i18n.t(i18nKeys.dropshippingStatus__redCardActivationAction),
  recievedKit: () =>
    i18n.t(i18nKeys.dropshippingStatus__redCardActivationRecievedKit),
  body: () => i18n.t(i18nKeys.dropshippingStatus__redCardActivationBody),
  legacyBody: () =>
    i18n.t(i18nKeys.dropshippingStatus__legacyRedCardActivationBody),
  helpButton: () =>
    i18n.t(i18nKeys.dropshippingStatus__redCardActivationHelpButton),
}

export const startDashing = {
  body: () => i18n.t(i18nKeys.dropshippingStatus__startDashingBody),
  future: () => i18n.t(i18nKeys.dropShippingStatus__startDashingBodyFuture),
  now: () => i18n.t(i18nKeys.dropShippingStatus__startDashingBodyNow),
  nowV2: () => i18n.t(i18nKeys.dropshippingStatus__v2__startDashingBodyNow),
  openAppButton: () =>
    i18n.t(i18nKeys.dropshippingStatus__startDashingOpenAppButton),
  getStartedButton: () =>
    i18n.t(i18nKeys.dropshippingStatus__startDashingGetStarted),
}

export const paymentSetup = {
  titleSubtext: () => i18n.t(i18nKeys.paymentSetup__titleSubtext),
  addBankAccount: () => i18n.t(i18nKeys.paymentSetup__addBankAccount),
  future: () => i18n.t(i18nKeys.paymentSetup__future),
}

export const fastPay = {
  description: () => i18n.t(i18nKeys.dropshippingStatus__fastPay__description),
  primaryButton: () => i18n.t(i18nKeys.dropshippingStatus__fastPay__primaryButton),
  secondaryButton: () => i18n.t(i18nKeys.dropshippingStatus__fastPay__secondaryButton),
  bankAccountAlert: () => i18n.t(i18nKeys.fastPay__addBankAccount__alert),
} 